import { render, staticRenderFns } from "./AppMenuEntry.vue?vue&type=template&id=7faa0c46&scoped=true"
import script from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
export * from "./AppMenuEntry.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./AppMenuEntry.vue?vue&type=style&index=0&id=7faa0c46&prod&scoped=true&lang=scss"
import style1 from "./AppMenuEntry.vue?vue&type=style&index=1&id=7faa0c46&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7faa0c46",
  null
  
)

export default component.exports